import { LitElement, html } from 'lit';

class ModelMeAIWelcome extends LitElement {
  static properties = {
    shouldShow: { type: Boolean }
  };

  constructor() {
    super();
    this.shouldShow = false; // Default to hidden
  }

  // Override createRenderRoot for Tailwind compatibility
  createRenderRoot() {
    return this; // Renders to light DOM
  }

  // Check query param when component is added to DOM
  connectedCallback() {
    super.connectedCallback();
    const urlParams = new URLSearchParams(window.location.search);
    // Show component if 'source' param is 'tryonhaulcentral'
    const thcSource = urlParams.get('source') === 'tryonhaulcentral';
    const hasSeenWelcome = Boolean(localStorage.getItem('has_seen_welcome'))
    if (thcSource && !hasSeenWelcome) {
      setTimeout(() => {
        document.getElementById('welcome_modal')?.showModal()
        localStorage.setItem('has_seen_welcome', 'y')
      }, 200)
    }
  }

  render() {
    return html`
      <dialog id="welcome_modal" class="modal">
        <div class="container mx-auto p-4 max-w-2xl modal-box">
            <div class="card bg-base-200 shadow-xl">
                <div class="card-body">
                    <h2 class="card-title text-2xl font-bold text-primary">
                        Welcome from TryOnHaulCentral!
                    </h2>
                    <p class="text-base-content mb-4">
                        Hey there! You’ve landed on ModelMeAI, where you can create endless outfit swaps 
                        with just a few clicks.
                    </p>
                    <div class="divider"></div>
                    <h3 class="text-xl font-semibold text-secondary">
                        How to Use ModelMeAI
                    </h3>
                    <ol class="list-decimal list-inside text-base-content space-y-2">
                        <li>
                            <span class="font-medium">Upload an Image:</span> Start by uploading a clear 
                            photo or screenshot of whoever you want to dress up.
                        </li>
                        <li>
                            <span class="font-medium">Select an Outfit:</span> Browse our collection and 
                            pick the perfect look—sexy, slutty, casual, or anything in between.
                        </li>
                        <li>
                            <span class="font-medium">Click "Generate Image":</span> Hit the magic button, 
                            and watch AI swap the outfit onto your photo in seconds!
                        </li>
                    </ol>
                    <div class="card-actions justify-center mt-6">
                        <button class="btn btn-primary" @click=${() => {
        document.getElementById('welcome_modal')?.close()
      }}>
                            Get Started Now
                        </button>
                    </div>
                </div>
            </div>
        </div>
    `;
  }
}

// Register the custom element
customElements.define('modelmeai-welcome', ModelMeAIWelcome);
